<template>
  <div class="contentBox min-w-1400">
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg1" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg2" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg3" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg4" alt="" class="imgItem" />
      </div>
    </div>
    <div class="flexBox min-w-1400">
      <div class="imgBox max-w-1400">
        <img :src="importedImg5" alt="" class="imgItem" />
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import importedImg1 from "@/page/consumerbusinessloan/components/img/index1.png";
import importedImg2 from "@/page/consumerbusinessloan/components/img/index2.png";
import importedImg3 from "@/page/consumerbusinessloan/components/img/index3.png";
import importedImg4 from "@/page/consumerbusinessloan/components/img/index4.png";
import importedImg5 from "@/page/consumerbusinessloan/components/img/index5.png";

export default {
  data() {
    return {
      importedImg1: importedImg1,
      importedImg2: importedImg2,
      importedImg3: importedImg3,
      importedImg4: importedImg4,
      importedImg5: importedImg5,
      altText: "图片",
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  },
};
</script>

<style scoped>
.contentBox {
  display: flex;
  flex-direction: column;
  background: #FCFCFC;
}
img {
  display: block;
}
.flexBox{
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}

.imgBox{
  margin: 0;
  overflow: hidden;
  width: 100%;
  background-color: "";
}

.imgItem {
  width: 100%;
  margin: 0;
}
</style>
